// extracted by mini-css-extract-plugin
export default {"anchor":"HomeLink_anchor__xOl-r","label":"HomeLink_label__T-XoJ","icon":"HomeLink_icon__66Mh9"};